module.exports = __webpack_public_path__ + "static/img/rank_163.c914d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_163.png
// module id = ++4k
// module chunks = 0